// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__fontMontserrat_2483b0', '__fontMontserrat_Fallback_2483b0'"},"className":"__className_2483b0"};